import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import unn from "../../data/unn.png";
import "../Admin/index.css";
import { API_BASE_URL, authFetch } from "../../config/api";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || !confirm) return setError("Please fill in all fields.");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    setError("");
    try {
      const res = await authFetch(`${API_BASE_URL}/api/users/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const json = await res.json();
      if (json.success) {
        navigate("/admin", { state: { message: "Password reset successfully. Please sign in." } });
      } else {
        setError(json.error || "Something went wrong.");
      }
    } catch {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin_login">
      <div className="admin_login_logos">
        <div className="admin_login_logo">
          <img src={unn} alt="unn_logo" />
        </div>
      </div>
      <div className="admin_login_title">
        <h1>Faculty of Pharmaceutical Sciences</h1>
        <h2>University of Nigeria Nsukka</h2>
      </div>
      <h2>Reset Password</h2>
      <form className="admin_login_form" onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirm new password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        {error && <p style={{ color: "red", fontSize: "0.85rem" }}>{error}</p>}
        <button type="submit" disabled={loading}>
          {loading ? "Resetting..." : "Reset Password"}
        </button>
        <Link to="/admin" className="admin_login_forgot">Back to Sign In</Link>
      </form>
    </div>
  );
}

export default ResetPassword;
